import { createSelector } from 'reselect'

import { RootState } from '../app/store'
import { Zone } from '../shared/types'

// return the full user profile, including detailed zone data
export const selectAllUserData = createSelector(
  [
    (state: RootState) => state.user.profile,
    (state: RootState) => state.user.loading,
    (state: RootState) => state.user.error,
    (state: RootState) => state.detectedZones.userCoords,
    (state: RootState) => state.detectedZones.data,
    (state: RootState) => state.detectedZones.loading,
    (state: RootState) => state.detectedZones.error,
    (state: RootState) => state.zone.data,
    (state: RootState) => state.zone.loading,
    (state: RootState) => state.zone.error,
    (state: RootState) => state.dossier.data,
    (state: RootState) => state.dossier.loading,
    (state: RootState) => state.dossier.error,
  ],
  (
    userProfile,
    userLoading,
    userError,
    userCoords,
    detectedZones,
    detectedZonesLoading,
    detectedZonesError,
    zone,
    zoneLoading,
    zoneError,
    dossier,
    dossierLoading,
    dossierError
  ): any | undefined => {
    let detectedZoneData = {}
    if (!userProfile) return undefined

    // include zone detailed data from detectedZones (if it  exsits)
    if (detectedZones && zone) {
      detectedZoneData = {
        ...detectedZones.find(
          (detectedZone: Zone) => detectedZone.id === zone.id
        ),
      }
    }

    return {
      userProfile,
      userCoords,
      zone: {
        ...zone,
        ...detectedZoneData,
      },
      dossier,
      loading: {
        user: userLoading,
        zone: zoneLoading,
        dossier: dossierLoading,
        detectedZones: detectedZonesLoading,
      },
      error: {
        user: userError,
        zone: zoneError,
        dossier: dossierError,
        detectedZones: detectedZonesError,
      },
    }
  }
)
